











import Vue from 'vue'
import { adjustDateToJp } from '@/utils'

export default Vue.extend({
  name: 'HistoryItem',
  props: {
    thumb: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    point: {
      type: Number,
      required: true
    },
    used: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    adjustDate(): string {
      return adjustDateToJp(this.date)
    },
    sign(): string {
      return this.used ? '-' : '+'
    }
  }
})
